export const Icon = () => {
    return (
        <svg viewBox="0 0 9 14" width="9" height="14" fill="none" stroke="#D4BC87">
            <path d="M8.16797 0.5L1.66797 7L8.16797 13.5" strokeLinecap="round" />
        </svg>
    );
};
